<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content class="custom-width">
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >

    @if (settingsData.contextIdsNames.length>1) {
      <div>
        <form [formGroup]="settingsForm" class="pe-1">
          <div class="input-group m-1">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>{{'selectContext' | translate}}</mat-label>
              <mat-select [(value)]="selected" formControlName="id" class="input-group m-1">
                @for (context of settingsData.contextIdsNames; track context) {
                  <mat-option value="{{context.id}}">{{context?.displayName}}</mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </form>
      </div>
    }

    <mat-card class="my-2">
      <mat-card-content class="p-3">
        @if (settingsData.contextIdsNames.length==1) {
          <div class="pe-2">
            <div class="d-flex align-items-center" style="justify-content: space-between;">
              <div><strong>{{'context' | translate}}</strong></div>
              <div><span class="text-muted">{{selectedName}}</span></div>
            </div>
            <mat-divider class="my-3"></mat-divider>
          </div>
        }

        <div class="d-flex align-items-center" style="justify-content: space-between;">
          <div><span>{{'user' | translate}}</span></div>
          <div><span class="text-muted">{{settingsData.user}}</span></div>
        </div>
      </mat-card-content>
    </mat-card>

  </section>
</div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (settingsData.contextIdsNames.length>1) {
    <div>
      @if (actualRoute!='/selectContext') {
        <button mat-button style="color:var(--warmOrange);" (click)="onCancelSettings();" >
          {{'cancel' | translate}}
        </button>
      }
      <button mat-button class="orange-button" (click)="onSaveSettings();"> {{'register.confirm' | translate}} </button>
    </div>
  }
  @if (settingsData.contextIdsNames.length==1) {
    <div>
      @if (actualRoute!='/selectContext') {
        <button mat-button style="color:var(--warmOrange);" (click)="onCancelSettings();" >
          {{'cancel' | translate}}
        </button>
      }
      <button mat-button class="orange-button" (click)="onSaveSettings();" [disabled]="contextLicenseFree"> {{'register.confirm' | translate}} </button>
    </div>
  }
</mat-dialog-actions>
